<div id="italoecu-logo">
    <a routerLink="/">
    <img src="../../../assets/logo/italoecu.png" class="logo"
        alt="ItaloEcu - Chiptuning für Alfa Romeo, Fiat, Lancia, Abarth, Jeep, Chrysler, Maserati, Ferrari aus Berlin"
        title="ItaloEcu - Chiptuning für Alfa Romeo, Fiat, Lancia, Abarth, Jeep, Chrysler, Maserati, Ferrari aus Berlin">
    </a>
</div>